import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['widgetContainer', 'widgetContent', 'resizeHandle']

  static values = {
    url: String,
  }

  toggleWidget(e) {
    e.currentTarget.classList.toggle('is-active')

    this.widgetContainerTarget.classList.toggle('is-visible')
  }

  connect() {
    this.loadWidth()
    if (this.hasResizeHandleTarget) {
      this.resizeHandleTarget.addEventListener('mousedown', this.startResize.bind(this))
    }
  }

  loadWidth() {
    const savedWidth = localStorage.getItem('sidebar-width')
    if (savedWidth && savedWidth.includes('px')) {
      let px = parseFloat(savedWidth.slice(0, -2))
      px = Math.max(50, Math.min(400, px))
      const clampedWidth = px + 'px'
      document.documentElement.style.setProperty('--sidebar-width', clampedWidth)
      if (this.hasWidgetContainerTarget) {
        this.widgetContainerTarget.style.flexBasis = clampedWidth
      }
    } else {
      localStorage.removeItem('sidebar-width')
    }
  }

  async initialize() {
    if (this.urlValue !== '') {
      const res = await fetch('/assistant_authenticate')
      const result = await res.json()

      if (res.ok && result.token) {
        this.execScript(this.urlValue + '/embed.js', result.token)
      } else {
        this.addErrorMessage(`Failed to authenticate! Error: ${result.error}`)
      }
    }
  }

  execScript(url, token) {
    let script = document.createElement('script')
    script.src = url
    script.onload = function () {
      let options = {
        access_token: token,
        pageContext: {},
        expandedWidth: '100%',
        expandedHeight: '100%',
      }
      embedWidget('widget-container', options)
      const iframe = document.querySelector('iframe')
      if (iframe) {
        iframe.style.setProperty('z-index', '1', 'important')
      }
    }

    this.widgetContainerTarget.append(script)
  }

  startResize(e) {
    e.preventDefault()
    e.stopPropagation()

    this.widgetContainerTarget.style.pointerEvents = 'none'

    const startX = e.clientX
    const startStyle = getComputedStyle(this.widgetContainerTarget)
    const startWidthPx = parseFloat(startStyle.flexBasis)

    // Drag states
    const body = document.body
    const originalUserSelect = body.style.userSelect
    const originalCursor = body.style.cursor
    const originalTransition = this.widgetContainerTarget.style.transition
    body.style.userSelect = 'none'
    body.style.cursor = 'col-resize'
    this.widgetContainerTarget.style.transition = 'none'

    const onMouseMove = (moveEvent) => {
      const deltaPx = moveEvent.clientX - startX
      let newWidthPx = startWidthPx - deltaPx
      newWidthPx = Math.max(50, Math.min(400, newWidthPx))

      const newWidth = `${newWidthPx}px`

      this.widgetContainerTarget.style.flexBasis = newWidth
      document.documentElement.style.setProperty('--sidebar-width', newWidth)
    }

    const onMouseUp = () => {
      const finalBasis = this.widgetContainerTarget.style.flexBasis
      let finalPx = 400 // default
      if (finalBasis && finalBasis.includes('px')) {
        finalPx = parseFloat(finalBasis.slice(0, -2))
      }
      localStorage.setItem('sidebar-width', finalPx + 'px')
      body.style.userSelect = originalUserSelect
      body.style.cursor = originalCursor
      this.widgetContainerTarget.style.transition = originalTransition
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)

      this.widgetContainerTarget.style.pointerEvents = 'auto'
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)
  }

  addErrorMessage(txt) {
    this.widgetContentTarget.classList.add('p-4', 'has-text-centered')
    let msg = document.createElement('p')
    msg.classList.add('has-text-danger')
    msg.innerText = txt
    this.widgetContentTarget.append(msg)
  }
}
